var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Horizontal-menu',{staticClass:"horiMenu",attrs:{"page":_vm.route}}),_c('CentersMap',{attrs:{"nord":_vm.nord,"sud":_vm.sud,"tech":_vm.tech,"loader":_vm.loaderStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }